module.exports = __webpack_public_path__ + "img/border_tr.a0661347.svg";